import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FeaturesService } from '../../features.service';
import { User } from 'src/app/modules/auth/user';
import { AppFeatures } from '../../types/app-features';
import { Store } from '@ngrx/store';
import { AppSelectors } from 'src/app/state/app/selectors';

@Component({
    selector: 'app-menu-panel',
    templateUrl: './menu-panel.component.html',
    styleUrls: ['./menu-panel.component.scss'],
    standalone: false
})
export class MenuPanelComponent {
  @Input() user: User;
  @Input() features: AppFeatures;
  @Output() routeClick = new EventEmitter<null>();

  userRegion$;

  constructor(private store: Store) {
    this.userRegion$ = this.store.select(AppSelectors.userRegion);
  }

  navClick() {
    this.routeClick.emit();
  }

}
